import React, {Component} from 'react'
import moment from 'moment-timezone'
import "../styles/index.scss"
import parseSearchQuery from "../../helpers/parseSearchQuery"
import {getListBoxes} from "../../../services/api/apiNextBox"
import NextBoxFBAPage from "./NextBoxFBAPage";


class NextBoxFBAPageContainer extends Component {
    state = {
        error: '',
        listBoxClosed: []
    }

    componentDidMount() {
        this._getListBox()
    }

    _getListBox = async () => {
        const boxId = this._parseBoxId()
        const boxesClosed = JSON.parse(localStorage.getItem('boxesClosed')) || []
        const thisBox = boxesClosed.find(boxClosed => boxClosed._id === boxId)

        if (thisBox !== undefined && thisBox.status === 'closed') {
            const asiaTime = moment.tz(thisBox.closed_at, "ASIA/HO_CHI_MINH")
            const beginDay = asiaTime.clone().tz("America/Noronha").format('YYYY-MM-DD')
            const start = moment(beginDay, 'YYYY-MM-DD', 'Asia/Ho_Chi_Minh').startOf('day').add(9, 'hours').toISOString()
            const end = moment(start).add(1, 'days').toISOString()

            try {
                this.setState({
                    error: ''
                })

                const {success, data, message} = await getListBoxes({
                    page: 1,
                    limit: 1000,
                    closed_at_gte: start,
                    closed_at_lt: end,
                    sort: 'closed_at.asc'
                })

                if (!success) {
                    return this.setState({
                        error: message
                    })
                }

                const {boxes} = Object.assign({}, data)

                this.setState({
                    listBoxClosed: Array.isArray(boxes) ? boxes : [],
                })
            } catch (e) {
                return this.setState({
                    error: e.message
                })
            }
        }
    }

    _updateListBox = async (closeAt) => {
        const asiaTime = moment.tz(closeAt, "ASIA/HO_CHI_MINH")
        const beginDay = asiaTime.clone().tz("America/Noronha").format('YYYY-MM-DD')
        const start = moment(beginDay, 'YYYY-MM-DD', 'Asia/Ho_Chi_Minh').startOf('day').add(9, 'hours').toISOString()
        const end = moment(start).add(1, 'days').toISOString()

        try {
            this.setState({
                error: ''
            })

            const {success, data, message} = await getListBoxes({
                page: 1,
                limit: 1000,
                closed_at_gte: start,
                closed_at_lt: end,
                sort: 'closed_at.asc'
            })

            if (!success) {
                return this.setState({
                    error: message
                })
            }

            const {boxes} = Object.assign({}, data)

            this.setState({
                listBoxClosed: Array.isArray(boxes) ? boxes : [],
            })
        } catch (e) {
            return this.setState({
                error: e.message
            })
        }
    }

    _parseBoxId = () => {
        const {boxId} = this.props.match.params

        return boxId
    }

    _isPrivate = () => {
        const {pass} = parseSearchQuery()

        return pass ? pass === 'admin' : false
    }

    render() {
        const {listBoxClosed, error} = this.state
        const boxId = this._parseBoxId()
        const isPrivate = this._isPrivate()
        const indexBoxClosed = listBoxClosed.findIndex(boxClosed => boxClosed._id === boxId)

        return (
            <div className="NextBoxPageContainer NextBoxFBAPageContainer">
                {error && <div className="text-danger">{error}</div>}

                <NextBoxFBAPage
                    isPrivate={isPrivate}
                    boxId={boxId}
                    indexBoxClosed={indexBoxClosed}
                    reloadClosedBox={this._updateListBox}
                />
            </div>
        )
    }
}

export default NextBoxFBAPageContainer
